import {usePhotosUpload} from '@features/photos-upload/store.ts'
import {IdleStep} from '@features/photos-upload/components/idle-step'
import {FC} from 'react'
import {UploadStep} from '@features/photos-upload/components/upload-step'

export const PhotosUploadModalRoot: FC<{initialMaxFiles: number; openSubmitModal: () => void}> = ({
    initialMaxFiles,
    openSubmitModal
}) => {
    const step = usePhotosUpload(store => store.step)

    return step == 'idle' ? (
        <IdleStep initialMaxFiles={initialMaxFiles} />
    ) : (
        <UploadStep openSubmitModal={openSubmitModal} />
    )
}
